import { isEmpty, upperCase } from "lodash";
import moment from "moment";

export const getUIFormatDate = (date) => {
  return date ? moment(date).format("DD MMM YYYY") : "";
};

export const getCardFormatDate = (date) => {
  return date ? moment(date).format("DD MMM, YY") : "";
};

export const getCapitalizedMonths = () => {
  return moment.monthsShort().map((item) => upperCase(item));
};
export const getDate = (date) => {
  return moment(date).date();
};
export const getMonth = (date) => {
  if (isEmpty(date)) return;
  const month = moment(date).month();
  return moment.monthsShort().find((item, Index) => month === Index);
};
export const formatDateMMDDYYYY = (date) => {
  return date ? moment(date).format("MM/DD/YYYY") : "";
};
